import {observable} from 'mobx';
import {construct, ModelProperties} from 'utils';

export class LocaleHistory {
    @observable id!: number;

    @observable value: string = '';

    @observable verified: boolean = false;

    @observable targetContentId!: number;

    @observable createdAt!: string;

    @observable userId?: number;

    @observable username?: string;

    constructor(content?: ModelProperties<LocaleHistory>) {
        if (content) {
            construct(this, content);
        }
    }
}